import { Filter, TextInput } from 'react-admin'

export default function CustomSearchFilter(props) {
  return (
    <Filter {...props}>
      <TextInput label='pos.search' source={props.columns.toString()} alwaysOn />
    </Filter>
  )
}
